var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevelopment1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 63,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.52 1.31h61.82v10H.52zm5 55.82h51.82v6H5.52z",
    fill: "#d6dbe9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.34 63.13H5.52m-5-61.82h61.82v55.82H.52zm0 10h61.82",
    stroke: "#204ecf",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.62 24.89l-9.2 9.14 9.2 9.13m23.18 0l9.2-9.13-9.2-9.14m-5.09-1.52l-13 21.31",
    stroke: "#204ecf",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#204ecf",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.19,
    cy: 5.31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.19,
    cy: 5.31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.19,
    cy: 5.31,
    r: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment1);
export default __webpack_public_path__ + "static/media/Development1.99894e8584f104e692219a63410c9bd1.svg";
export { ForwardRef as ReactComponent };